import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { ProductGroupEntity } from '../../../apis/dealsAPI'

export const PRODUCTS_QUERY_KEY = ['deal-catalog', 'products'] as const

const FIVE_MINUTES_MS = 5 * 60 * 1000

export function useProductsQuery(): UseQueryResult<ProductGroupEntity[]> {
  return useQuery<ProductGroupEntity[]>(PRODUCTS_QUERY_KEY, () => dealsAPI.listProducts(), {
    staleTime: FIVE_MINUTES_MS,
  })
}
